export default {
	text: "{changedBy} assigned the KR <a href='#' data-action='key-result'>{name}</a> to {to} (previously assigned to {from})",
};
